import { render, staticRenderFns } from "./FormFieldDesigner.vue?vue&type=template&id=32b4e150&scoped=true&"
import script from "./FormFieldDesigner.vue?vue&type=script&lang=js&"
export * from "./FormFieldDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b4e150",
  null
  
)

export default component.exports